module.exports = __webpack_public_path__ + "static/media/mGlobalBanner.3a37ce2f.svg";